var $63eb283d27decb4d$exports = {};
"use strict";
// Navigation- Mobile
const $63eb283d27decb4d$var$navBtn = document.querySelector(".menuicon");
const $63eb283d27decb4d$var$menuIcon = document.querySelector(".menuicon");
const $63eb283d27decb4d$var$mobileNav = document.querySelector(".mobile-nav");
const $63eb283d27decb4d$var$mobileNavList = document.querySelector(".mobile-nav-list");
const $63eb283d27decb4d$var$headerDoc = document.querySelector(".header");
// State
let $63eb283d27decb4d$var$state = "closed";
$63eb283d27decb4d$var$navBtn.addEventListener("click", function() {
    if ($63eb283d27decb4d$var$state === "closed") {
        $63eb283d27decb4d$var$headerDoc.style.height = "25rem";
        $63eb283d27decb4d$var$headerDoc.classList.toggle("header-mob");
        $63eb283d27decb4d$var$menuIcon.classList.toggle("menuicon-open");
        setTimeout(function() {
            $63eb283d27decb4d$var$mobileNav.style.display = "flex";
            $63eb283d27decb4d$var$mobileNavList.style.display = "flex";
        }, 600);
        $63eb283d27decb4d$var$state = "open";
    } else if ($63eb283d27decb4d$var$state === "open") {
        $63eb283d27decb4d$var$headerDoc.classList.toggle("header-mob");
        $63eb283d27decb4d$var$menuIcon.classList.toggle("menuicon-open");
        $63eb283d27decb4d$var$mobileNav.style.display = "none";
        $63eb283d27decb4d$var$mobileNavList.style.display = "none";
        setTimeout(function() {
            $63eb283d27decb4d$var$headerDoc.style.height = "9.6rem";
        }, 200);
        $63eb283d27decb4d$var$state = "closed";
    }
});
//////////////////////////////////////////
// Smooth Scrolling
/////////////////////////////////////////
const $63eb283d27decb4d$var$eventList = function(elname, secName) {
    const el = document.querySelectorAll(`${elname}`);
    const section = document.getElementById(secName);
    el.forEach((elem)=>elem.addEventListener("click", function() {
            console.log(section);
            section.scrollIntoView({
                behavior: "smooth"
            });
        }));
};
$63eb283d27decb4d$var$eventList(".about", "how");
$63eb283d27decb4d$var$eventList(".services", "how");
$63eb283d27decb4d$var$eventList(".testimonials", "how");
$63eb283d27decb4d$var$eventList(".plans", "how");
$63eb283d27decb4d$var$eventList(".contact", "how");
// imports
// import "../node_modules/core-js/stable";
// import "regenerator-runtime/runtime";
const $63eb283d27decb4d$var$texts = [
    "#comprehensive-cont",
    "#exhaustive-cont"
];
const $63eb283d27decb4d$var$cards = [
    "#comprehensive-card",
    "#exhaustive-card"
];
let $63eb283d27decb4d$var$currentIndex = 0;
const $63eb283d27decb4d$var$forwardBtn = document.querySelector("#arrow-right");
const $63eb283d27decb4d$var$backBtn = document.querySelector("#arrow-left");
$63eb283d27decb4d$var$forwardBtn.addEventListener("click", (e)=>{
    $63eb283d27decb4d$var$currentIndex = ($63eb283d27decb4d$var$currentIndex + 1) % $63eb283d27decb4d$var$texts.length;
    $63eb283d27decb4d$var$texts.map((el, i)=>{
        const text = document.querySelector(el);
        if (i != $63eb283d27decb4d$var$currentIndex) {
            text.style.display = "none";
            text.style.opacity = "none";
        } else {
            text.style.display = "flex";
            text.style.opacity = "100%";
        }
    });
    $63eb283d27decb4d$var$cards.map((el, i)=>{
        const card = document.querySelector(el);
        if (i != $63eb283d27decb4d$var$currentIndex) {
            card.style.display = "none";
            card.style.opacity = "none";
        } else {
            card.style.display = "flex";
            card.style.opacity = "100%";
        }
    });
});
$63eb283d27decb4d$var$backBtn.addEventListener("click", (e)=>{
    $63eb283d27decb4d$var$currentIndex = $63eb283d27decb4d$var$currentIndex - 1;
    if ($63eb283d27decb4d$var$currentIndex < 0) $63eb283d27decb4d$var$currentIndex = 0;
    $63eb283d27decb4d$var$texts.map((el, i)=>{
        const text = document.querySelector(el);
        if (i != $63eb283d27decb4d$var$currentIndex) {
            text.style.display = "none";
            text.style.opacity = "none";
        } else {
            text.style.display = "flex";
            text.style.opacity = "100%";
        }
    });
    $63eb283d27decb4d$var$cards.map((el, i)=>{
        const card = document.querySelector(el);
        if (i != $63eb283d27decb4d$var$currentIndex) {
            card.style.display = "none";
            card.style.opacity = "none";
        } else {
            card.style.display = "flex";
            card.style.opacity = "100%";
        }
    });
});


//# sourceMappingURL=index.05f08f29.js.map
